import * as React from "react";

import { Tag } from "@impero-com/ui";
import { Popover } from "antd";

import { popoverItems } from "./hoverableItemList.css";

interface HoverableItemListProps {
    label: string;
    items: Array<string>;
}

class HoverableItemList extends React.Component<HoverableItemListProps> {
    render(): React.ReactNode {
        const { label, items } = this.props;

        const mainTag = (
            <Tag>
                <b>{label}</b>
            </Tag>
        );

        if (items.length === 0) {
            // No Popover if there are no items inside
            return mainTag;
        } else {
            const popoverContent = (
                <div className={popoverItems}>
                    {items.map((item) => (
                        <Tag key={item}>{item}</Tag>
                    ))}
                </div>
            );
            return <Popover content={popoverContent}>{mainTag}</Popover>;
        }
    }
}

export { type HoverableItemListProps, HoverableItemList };
